// This is new runtime config which mapped to configMap at GKE (configMap.json - realtime injection).
// This file contains the default values for the runtime configuration flags in case of failure to fetch the configMap from GKE or intended empty
// If you want to overwrite the default values, you should provide a configMap.json at GKE with the desired flags.
// Usage 1: GKE console → ConfigMap → Edit → update the data value: {"showRouteOptimizer":false,"routeOptimizerDefault":false} (double quotes required — valid JSON)
// Usage 2: kubectl patch configmap <name> -n custcntrct-d2c --patch '{"data":{"configMap.json":"{\"showRouteOptimizer\":false,\"routeOptimizerDefault\":false}"}}'

// IRuntimeConfig — interface for runtime feature flags loaded from the GKE configmap (configMap.json).
// Add new flags here as optional boolean properties.
export interface IRuntimeConfig {
  showRouteOptimizer?: boolean;
  routeOptimizerDefault?: boolean;
}

// defaultConfigMapValue — used when configMap.json cannot be fetched (local dev without GKE
// mount, or network/mount failure). Also fills in any keys missing from the fetched file.
export const defaultConfigMapValue: IRuntimeConfig = {
  showRouteOptimizer: true,
  routeOptimizerDefault: true,
};
